import { ISolicitationRepository } from '@/core/domain/repositories/ISolicitationRepository'
import { SolicitationAggregates } from '@/core/domain/entities/Ride'
import { Result, createOk, createErr } from '@/core/shared/utils/Result'
import { UserId, DateRangeString } from '@/core/shared/types'
import { GraphQLClientInterface } from '@/infrastructure/graphql/apolloClient'
import { GET_SOLICITATION_AGGREGATES } from '@/infrastructure/graphql/queries/rideQueries'

export class GraphQLSolicitationRepository implements ISolicitationRepository {
  constructor(private readonly graphqlClient: GraphQLClientInterface) {}

  async getSolicitationAggregates(
    userId: UserId,
    dateRange?: DateRangeString
  ): Promise<Result<SolicitationAggregates, Error>> {
    try {
      const variables: {
        userId: UserId
        dateStart?: string
        dateEnd?: string
      } = { userId }

      if (dateRange) {
        variables.dateStart = dateRange.start.split('T')[0]
        variables.dateEnd = dateRange.end.split('T')[0]
      }

      const data = await this.graphqlClient.query<{
        solicitationAggregates: SolicitationAggregates
      }>({
        query: GET_SOLICITATION_AGGREGATES,
        variables,
      })

      return createOk(data.solicitationAggregates)
    } catch (error) {
      console.error('Failed to fetch solicitation aggregates:', error)
      return createErr(
        error instanceof Error ? error : new Error('Unknown error occurred')
      )
    }
  }
}
